<template>
  <div v-if="!isCookieBotEnabled" class="cookie-consent">
    <div class="cookie-consent__info">
      <Wysiwyg v-if="$route.params.language === 'de'">
        Diese Website nutzt Cookies, um bestmögliche Funktionalität bieten zu können.
        Mehr dazu in unseren
        <AppLink
          :is-link="privacyPage && privacyPage.url"
          :to="privacyPage && privacyPage.url"
        >
          Datenschutzinformationen.
        </AppLink>
      </Wysiwyg>
      <Wysiwyg v-else>
        This website is using cookies to give you the best possible functionality. You can read more on that in our
        <AppLink
          :is-link="privacyPage && privacyPage.url"
          :to="privacyPage && privacyPage.url"
        >
          privacy policy.
        </AppLink>
      </Wysiwyg>
    </div>
    <div class="cookie-consent__actions">
      <Button
        type="primary"
        @click="accept"
      >
        Annehmen
      </Button>
      <Button
        type="bare"
        @click="decline"
      >
        Ablehnen
      </Button>
    </div>
  </div>
</template>

<script>
import { Page } from 'beisheim/models'
import Button from 'beisheim/components/elements/button'
import Wysiwyg from 'beisheim/components/elements/wysiwyg'
import AppLink from 'beisheim/components/elements/app-link'

export default {
  components: {
    Wysiwyg,
    Button,
    AppLink
  },
  props: {
    locale: {
      type: Object,
      required: true
    }
  },
  computed: {
    isCookieBotEnabled () {
      return !this.$cms && process.env.COOKIEBOT_ID
    },
    privacyPage () {
      return Page
        .where(r => r.language === this.locale.columns.language && r.country === this.locale.columns.country)
        .where(r => r.name === 'privacy').first()
    }
  },
  methods: {
    accept () {
      this.$store.dispatch('cookies/accept')
    },
    decline () {
      this.$store.dispatch('cookies/decline')
    }
  }
}
</script>

<style lang="scss">
@import 'beisheim/scss/breakpoints';
@import 'beisheim/scss/font';
@import 'beisheim/scss/colors';
@import 'beisheim/scss/scale';

.cookie-consent {
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: fixed;
  bottom: 0;
  left: 0;
  z-index: 100;
  width: 100%;
  background: #fff;
  border-top: 2px solid gray(3);
  padding: scale(4);

  @include to(2) {
    flex-direction: column;
  }

  &__actions {
    white-space: nowrap;

    @include to(2) {
      margin-top: scale(4);
    }

    @include from(3) {
      margin-left: scale(4);
    }
  }
}
</style>
